export const EXTERNAL_SERVICE_CODE = {
  TUYA: "TUYA",
  DREAME: "DREAME",
} as const;

export type ExternalServiceCodeType =
  (typeof EXTERNAL_SERVICE_CODE)[keyof typeof EXTERNAL_SERVICE_CODE];

/**
 * 入力値を ExternalServiceCodeType に変換する。不正な値の場合 undefined を返す
 */
export const parseExternalServiceCodeType = (
  value: string
): ExternalServiceCodeType | undefined => {
  const values = Object.values(EXTERNAL_SERVICE_CODE);
  return values.includes(value as ExternalServiceCodeType)
    ? (value as ExternalServiceCodeType)
    : undefined;
};

export const isDreameExSrv = (code: string): boolean => {
  const parsed = parseExternalServiceCodeType(code);
  if (!parsed) return false;

  if (parsed !== EXTERNAL_SERVICE_CODE.DREAME) return false;

  return true;
};
